
<template>
    <div id="thorne-verified" class="thorne-verified pt-12">
        <div class="mb-6 border-b border-gray-300 pb-[1.07rem]">
            <div class="flex items-center space-x-2">
                <Heading :level="4" color="text-ash-200">Thorne Verified</Heading>
            </div>
        </div>
        <div class="tags flex flex-wrap items-center justify-start">
        <NuxtLink
            class="cursor-pointer bg-white text-ash-200 px-[0.643rem] mr-2 mb-2 border border-ash-300 rounded-[0.2142857143rem] flex justify-center items-center h-[1.714rem] text-[0.857rem] hover:underline"
            :aria-label="tag.label"
            v-for="(tag, index) in thorneVerifiedData"
            :key="index"
            :to="tag.link"
            :title="tag.label"
            :id="`tv-${index}`"
            external
        >
            <Icon :icon="tag.icon" class="mr-[0.357rem]" />
            {{ tag.label }}
        </NuxtLink>
        </div>
    </div>
</template>

<script setup lang="ts">
import Heading from "../../../atom/heading.vue"
import Icon from "../../../atom/icon.vue"

defineProps<{
    thorneVerifiedData?: { label: string; link: string; icon: string }[]
}>()

</script>
